import React, { FC } from 'react';

interface ISideMenu {
  className: string;
}
const SideMenu: FC<ISideMenu> = (props) => (
  <svg
    {...props}
    width="4"
    height="16"
    viewBox="0 0 4 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00016 4.1111C2.92238 4.1111 3.66683 3.36666 3.66683 2.44444C3.66683 1.52222 2.92238 0.777771 2.00016 0.777771C1.07794 0.777771 0.333496 1.52222 0.333496 2.44444C0.333496 3.36666 1.07794 4.1111 2.00016 4.1111ZM2.00016 6.33333C1.07794 6.33333 0.333496 7.07777 0.333496 7.99999C0.333496 8.92221 1.07794 9.66666 2.00016 9.66666C2.92238 9.66666 3.66683 8.92221 3.66683 7.99999C3.66683 7.07777 2.92238 6.33333 2.00016 6.33333ZM2.00016 11.8889C1.07794 11.8889 0.333496 12.6333 0.333496 13.5555C0.333496 14.4778 1.07794 15.2222 2.00016 15.2222C2.92238 15.2222 3.66683 14.4778 3.66683 13.5555C3.66683 12.6333 2.92238 11.8889 2.00016 11.8889Z"
      fill="#545F7D"
    />
  </svg>
);

export default SideMenu;
